import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-my-registrations-status-pill',
  standalone: false,
  templateUrl: './my-registrations-status-pill.component.html',
  styleUrls: ['./my-registrations-status-pill.component.css']
})
export class MyRegistrationsStatusPillComponent {
  @Input() row!: { status: string };

  get statusClass(): string {
    const status = (this.row?.status || '').toLowerCase();

    switch (status) {
      case 'expiring soon':
      case 'expired':
        return 'status-pill warning';

      default:
        return 'status-pill';
    }
  }
}
